import axios from "axios";
import { API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
 
const getToken = () => {
    return localStorage.getItem("token");
}
export const SearchRoute = async (requestData, routeId, ShiftValue, date) => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetRouteTrackingByRouteId?routeId=${routeId}&ShiftValue=${ShiftValue}&date=${date}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response.data;
 
    } catch (error) {
        throw error
    }
}
 
export const ViewPoints = async (requestData) => {
    try {
        const response = await axiosInstance.post(API_BASE_URL1 + `tracking/getPointsData`, requestData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response.data;
 
    } catch (error) {
        throw error
    }
}
 
export const getByZoneCircleId = async (zoneId, circleId) => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `route/getByZoneCircleId/${zoneId}/${circleId}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};